import React, { lazy, Suspense } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { PaymentContext } from './data/context';
import { authContext } from './data/authContext';
import { ContextProvider } from "./context";
import { homePageService } from "./jwt/_services/home-page-service";
import './assets/css/style.css';
import AuthenticateUser from "./aws-pool/authenticate-user";
import Header from './section/header/header';
import Footer from './section/footer/footer';
import { CognitoUser, AuthenticationDetails, CognitoUserPool } from "amazon-cognito-identity-js";
//import { EMAIL_AWS_COGNITO, PASSWORD_AWS_COGNITO, USER_NAME_AWS_COGNITO, } from "../src/common";
import { PASSWORD_AWS_COGNITO, USER_NAME_AWS_COGNITO, EMAIL_AWS_COGNITO } from "./common/constant";
import getAuthPool from "../src/aws-pool/auth-aws";
import ConnectionError from './views/error-pages/connection-error';
import { history } from "./jwt/_helpers";
import dummyData from './views/CPAS/dummy.json';
import Loader from './views/CPAS/loader';
import { decryptData, encryptData, getSecret, SSMKeys } from "./common/common";

const CPAS = lazy(() => import('./views/CPAS'));
const PaymentToCause = lazy(() => import('./views/payments/cause'));
const PaymentToCampaign = lazy(() => import('./views/payments/campaign'));
const PaymentToAdoptArtwork = lazy(() => import('./views/payments/adopt-artwork'));
const PaymentToPatron = lazy(() => import('./views/payments/patron'));
const CampaignCpassDetails = lazy(() => import('./views/details-cpass-campaigns'));
const CampaignDetails = lazy(() => import('./views/details-campaign'));
const ArtWorkDetails = lazy(() => import('./views/details-artwork'));
const PatronProgrammeDetaiils = lazy(() => import('./views/details-patron-programme'));
const AllCausesCampaigns = lazy(() => import('./views/all-causes-campaigns'));
const AllAdoptArtWork = lazy(() => import('./views/all-artworks'));
const AllDonorsWall = lazy(() => import('./views/all-donors-wall'));
const UserProfile = lazy(() => import('./views/profile'));
const ReceiptDonation = lazy(() => import('./views/receipts/receipt'));
const RegistrationForTaxDeduction = lazy(() => import('./views/register/tax-deduction'));
//const AllPatronProgrammes = lazy(() => import('./views/all-patron-programmes'));

const disableConsole = ()=>{
   if(process.env.NODE_ENV === "production"){
     console.log = () => {};
   }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: window.location.host,
      isDataLoaded: false,
      settingsData: [],
      isOnline: window.navigator.onLine,
      isAuthorised: false
    }

    // setTimeout(() => { AuthenticateUser() }, 2000)
    this.getHomePageData = this.getHomePageData.bind(this);
    this.getAuthorisedHomePage = this.getAuthorisedHomePage.bind(this);
    this.updateConnection = this.updateConnection.bind(this);
    disableConsole()
  }

  getHomePageData() {
    //let response = dummyData;
    /* if (response) {
      response.PaymentContext = PaymentContext;
      this.setState({
        settingsData: response ?? [],
        isDataLoaded: true
      });
    } else {
      this.setState({
        isOnline: false,
        isDataLoading: true,
        settingsData: []
      })
    } */
    homePageService.getHomePageSettings()
      .then(response => {
        if (response) {
          response.PaymentContext = PaymentContext;
          this.setState({
            settingsData: response ?? [],
            isDataLoaded: true
          });
        } else {
          this.setState({
            isOnline: false,
            isDataLoading: true,
            settingsData: []
          })
        }
      });
  }

  async getAuthorizerDetails() {
    let poolId = await getSecret(SSMKeys.authPoolId).then((res) => decryptData(res));
    let clientId = await getSecret(SSMKeys.authClientId).then((res) => decryptData(res));

    return {
      UserPoolId: poolId,
      ClientId: clientId
    };
  }

  //isLoadHomePage allow to load homepage data boolian flag
  getAuthorisedHomePage(isLoadHomePage, poolDetails) {
    //const authAwsPool = getAuthPool();
    const user = new CognitoUser({
      Username: USER_NAME_AWS_COGNITO,
      Pool: new CognitoUserPool(poolDetails),
    });

    const authDetails = new AuthenticationDetails({
      Username: USER_NAME_AWS_COGNITO,
      Password: PASSWORD_AWS_COGNITO,
    });

    user.authenticateUser(authDetails, {
      onSuccess: (data) => {
        // localStorage.setItem("accessToken", data.)AccessToken, IdToken, RefreshToken, TokenType=Bearer
        authContext.AccessToken = data.accessToken.jwtToken
        authContext.IdToken = data.idToken.jwtToken
        authContext.RefreshToken = data.refreshToken.token
        // authContext.TokenType = data.refreshToken.token 
        if (isLoadHomePage) {
          this.getHomePageData();
        } else {
          this.setState({
            isDataLoaded: true
          })
        }
        this.setState({
          isAuthorised: true
        })
      },
      onFailure: (error) => {
        console.error("onFailure: ", error);
      },
      newPasswordRequired: (response) => {
        const userAttributes = {
          'email': EMAIL_AWS_COGNITO
        }
        console.log("newPasswordRequired: ", userAttributes, response);
        user.completeNewPasswordChallenge(PASSWORD_AWS_COGNITO, userAttributes, {
          onSuccess: (result) => {
            console.log("NEW PASSWORD COMPLETED: New Password Set");
            // console.log(result);
          },
          onFailure: (err) => {
            // console.log(err);
          }
        })
      },
    })
  }

  updateConnection(status) {
    this.setState({
      isOnline: status
    })
  }

  componentDidMount() {
    this.getAuthorizerDetails()
      .then(poolDetails => {
        if (window.location.pathname.indexOf('/receipt') !== -1 || window.location.pathname.indexOf('/register') !== -1) {
          this.getAuthorisedHomePage(false, poolDetails)
        } else {
          this.getAuthorisedHomePage(true, poolDetails)
        }

        if (window.location.pathname.indexOf('/receipt') !== -1 || window.location.pathname.indexOf('/register') !== -1) {
          this.getAuthorisedHomePage(false, poolDetails)

          // this.setState({ isDataLoaded: true });
        } else {
          this.getAuthorisedHomePage(true, poolDetails)
          // this.getHomePageData();
        }

        this.unlisten = history.listen(location => {

        });
      });

    console.log(this.state.isOnline, "online");
    window.addEventListener('offline', () => this.updateConnection(false))
    window.addEventListener('online', () => this.updateConnection(true))
  }

  render() {
    return (
      <>
        {this.state.isOnline ?
          <>
            {
              this.state.isDataLoaded && this.state.isAuthorised ?
                window.location.pathname.indexOf('/receipt') !== -1 || window.location.pathname.indexOf('/register') !== -1 ?
                  <BrowserRouter>
                    <Suspense fallback={<Loader />}>
                      <Switch>
                        <Route exact path="/receipt/donation" component={ReceiptDonation} />
                        <Route exact path="/receipt/adoption" component={ReceiptDonation} />
                        <Route path="/register/tax-deduction" component={RegistrationForTaxDeduction} />
                      </Switch>
                    </Suspense>
                  </BrowserRouter>
                  :
                  <ContextProvider value={this.state.settingsData}>
                    {
                      <BrowserRouter>
                        <Header />
                        {this.state.isOnline ?
                          <Suspense fallback={<Loader />}>
                            <Switch>
                              <Route exact path="/payments" component={PaymentToCause} />
                              <Route exact path="/campaign/payment" component={PaymentToCampaign} />
                              <Route exact path="/adoptnow/payment" component={PaymentToAdoptArtwork} />
                              <Route exact path="/patrons/payment" component={PaymentToPatron} />
                              {/* <Route exact path="/campaign" component={CampaignDetails} />
                              <Route exact path="/adopt-artwork" component={ArtWorkDetails} /> */}
                              <Route exact path="/campaign" component={()=><CampaignCpassDetails navURL='no-name' />} />
                              <Route exact path="/campaign/:campaignId" component={CampaignCpassDetails} />
                              <Route exact path="/adoptnow/:artworkId" component={ArtWorkDetails} />
                              <Route exact path="/patrons" component={PatronProgrammeDetaiils} />
                              <Route exact path="/all/causes-and-campaigns" component={AllCausesCampaigns} />
                              <Route exact path="/all/adoptnow" component={AllAdoptArtWork} />
                              <Route exact path="/all/patrons" component={PatronProgrammeDetaiils} /> {/* AllPatronProgrammes */}
                              <Route exact path="/all/donors-wall" component={AllDonorsWall} />
                              <Route exact path="/profile" component={UserProfile} /> {/* User Profile */}
                              {/* <Route exact path="/aws-pool" component={AuthenticateUser} /> // AuthenticateUser - Cognito Auth Test component
+                              <Route exact path="/signpass/confirmation" component={AuthenticateUser} /> */}
                              <Route path="/" component={CPAS} />
                            </Switch>
                          </Suspense> :
                          <ConnectionError></ConnectionError>
                        }
                        <Footer />
                      </BrowserRouter>
                    }
                  </ContextProvider>

                : <Loader />
            }
          </> :
          <ConnectionError></ConnectionError>
        }
      </>
    )
  }
}

export default App;
